<div class="search-block">
<div class="container">
<div>
<div>
<div id="home_nav" class="row">
  <div class="col-md-6 col-7 col-lg-6 breadcrumb-header">
    <ol class="breadcrumb ">
      <li class="breadcrumb-item" style="align-items: center;float:right;">
        <a class="bd-crumb-inactive" style="cursor: pointer;" (click)="getCurrentPage('home')">Home</a>
      </li>
      <li class="breadcrumb-item">
        <a class="bd-crumb-inactive" style="cursor: pointer;" (click)="getCurrentPage('browse')">Help Articles</a>
      </li>
      <li class="breadcrumb-item">
        <a class="bd-crumb-inactive" *ngIf=this.parent style="cursor: pointer;" (click)="handleNavigation(this.parentPk)">{{parent}}</a>
      </li>
      <li class="breadcrumb-item active" *ngIf=this.name>{{topicName}}</li>
    </ol>
  </div>
  <div class="input-group col-md-5 col-5 col-lg-5 searchContainer">
    <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword"
      [(ngModel)]="searchKey" (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)'
      (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate"
      (keydown.enter)="onKeyEnterSearch($event,searchKey)" (inputCleared)="searchCleared()" aria-label="Type here to Search an Article"
      placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a [innerHTML]="item.name"></a>
    </ng-template>
    <ng-template #notFoundTemplate let-notFound>
      No Suggestion...
    </ng-template>
    <span class="input-group-append" (click)="search(searchKey)">
      <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
        <i class="fa fa-search"></i>
      </button>
    </span>
  </div>
</div>
<div data-auto-dismiss="10000"  *ngIf="alert==true && delayed==false"
  class="alert alert-success alert-dismissible fade show" style="position: absolute; right: 20px; z-index: 999;margin-top: 10px;padding: 0.75rem 1rem;" data-auto-dismiss role="alert">
    <p>Case saved successfully, case number is {{caseAlertMessage}}</p>
</div>
</div>
</div>
</div>
</div>
<div class="container">
  <h2 class="help" >{{topicName}}</h2>
  </div>
<div class="container p-10">
<div class="row articles" *ngIf = "chaildTopics?.return_body.length > 0"  status="false">
  <div class="col-lg-6"  *ngFor="let topic of chaildTopics?.return_body">
    <div *ngIf="topic.parentPk==this.pk">
    <ul style="list-style-type: none;margin: 0px -6px;">
    <p class="help-topics-header"  (click)=navigate(topic.parentPk,this.parentPk,topic.pk)>{{topic.stepName}}<span class="topics-count" *ngIf="topic.kbData.count > 0">({{topic.kbData.count}})<i class="fas fa-angle-double-right right-arrow"></i></span></p>
    <ng-container *ngFor="let kb of topic.kbData.items;let i= index">
      <li *ngIf="i<3" > 
        <a [routerLink]="['../article']" [queryParams]="{articleId: kb.id,pk:this.pk,childPk:this.parentPk,articleTag:topic.articleTag}">
          <h6 class="article-topic"  [innerHTML]="kb.name"></h6>
        </a>
      </li>
    </ng-container>
  </ul>
</div>
</div>
</div>
    <div *ngIf = "topics?.return_body.length > 0"  status="false">
      <div *ngFor="let topic of topics?.return_body">
        <div *ngIf="topic.pk==this.pk">
      <div class="col-lg-8" >
        <h4 class="aricles-header" class="topic" *ngIf="topic.kbData.count">{{topic.kbData.count}} articles found for "{{topic.stepName}}"</h4>
        <hr>
        <ul style="list-style-type: none;margin: 0px -35px;" *ngFor="let kb of topic.kbData.items">
          <li class="line" >
            <a [routerLink]="['../article']" [queryParams]="{articleId: kb.id,pk:this.pk,childPk:this.childPk,articleTag:topic.articleTag}">
              <h4 class="article-topic" [innerHTML]="kb.name"></h4>
            </a>
            <p [innerHTML]=kb.frag_data ></p>
          </li>
        </ul>
      </div>
      </div>
    </div>
    </div>
  
<div *ngIf="topics?.return_body.length == 0">
  <div class="empty-record" style="padding-left: 51px;">No results found. Please modify your search criteria.</div>
  <div class="col-sm-4 col-md-12 col-lg-12 col-xl-4 contact"  *ngIf = "topics?.return_body.length > 0">
    <div class="contact-link">
      <div class="card" style="width: 100%;" id="shp-articles-body">
        
        <div class="card-header"  *ngIf = "topics?.return_body.length > 0" id="shp-articles-header">
          <strong>Related articles</strong>
        </div>
        <div class="card-body"  *ngIf = "topics?.return_body.length > 0" id="shp-articles-content">

          <ul style="list-style-type:none;padding-left: 20px;">
            <a href="#" *ngFor="let article of topic.kbData.items">
              <li class="toparticles-block">{{article.article_title}}</li>
            </a>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</div>